import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_ORG_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/users/index'

export const Route = createFileRoute('/users/(deprecated_routes)/$orgID')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_ORG_ID]: params.orgID,
      }),
      replace: true,
    })
  },
})
